import type { SiteContactPublic } from '../types/siteContact.js';

type MainAddressVisibility = Pick<SiteContactPublic, 'mainAddressVisible'>;

/**
 * Whether the company office address (company-contacts `general:address`) may appear
 * on public pages / anonymous APIs. Independent of CAN-SPAM postalAddressMultiline.
 */
export function isPublicMainAddressVisible(
  profile: MainAddressVisibility | null | undefined,
): boolean {
  return profile?.mainAddressVisible === true;
}

/** Trimmed office address only when visible and non-empty; otherwise null. */
export function resolvePublicMainAddress(
  profile: MainAddressVisibility | null | undefined,
  address: string | null | undefined,
): string | null {
  if (!isPublicMainAddressVisible(profile)) {
    return null;
  }
  const trimmed = address?.trim();
  return trimmed || null;
}

export type PublicCompanyContactVisibility = {
  addressVisible: boolean;
  phoneVisible: boolean;
};

/**
 * Whether a company_contact_channels `type` may be included in anonymous public primary payloads.
 * Address and phone follow site-contact visibility flags; other types stay public.
 */
export function includeCompanyContactTypeInPublicPrimary(
  type: string,
  visibility: PublicCompanyContactVisibility,
): boolean {
  switch (type) {
    case 'address':
      return visibility.addressVisible;
    case 'phone':
      return visibility.phoneVisible;
    default:
      return true;
  }
}
